<template>
    <div>
        <section class="content-header mt-2">
            <h3><font-awesome-icon icon="user-circle" /> Edit Account</h3>
            <b-nav tabs>
                <router-link tag='li'
                             :to="{ name: 'account' }"
                             class="nav-item">
                    <a class="nav-link" v-bind:class="{ active: editProfile }">Profile</a>
                </router-link>
                <router-link tag='li'
                             :to="{ name: 'account.password' }"
                             class="nav-item">
                    <a class="nav-link" v-bind:class="{ active: editPassword }">Password</a>
                </router-link>
            </b-nav>
        </section>
        <success-component
                v-if="success.length > 0"
                :message="success">
        </success-component>
        <error-component
                v-if="exceptions.length > 0"
                v-bind="exceptions[0]">
        </error-component>
    </div>
</template>

<script>
    import ErrorComponent from '../../components/ErrorView.vue';
    import SuccessComponent from '../../components/Success.vue';

    import { mapState } from 'vuex';

    export default {
        name: "Tabs",
        components: {
            ErrorComponent,
            SuccessComponent,
        },
        computed: {
            ...mapState({
                success: 'success',
                exceptions: 'exceptions',
            }),
        },
        created() {
            let name = this.$route.name;
            if (name === "account" || name === "account.email.activate.logged") {
                this.editProfile = true;
                this.editPassword = false;
            }
            else {
                this.editProfile = false;
                this.editPassword = true;
            }
        },
        data: function () {
            return {
                editProfile: false,
                editPassword: false,
            }
        }
    }
</script>

<style scoped>

</style>